package com.trevorwiebe.timesheet.core.domain

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

object DeepLinkState {
    private val _pendingDestination = MutableStateFlow<String?>(null)
    val pendingDestination: StateFlow<String?> = _pendingDestination.asStateFlow()

    fun setDestination(destination: String?) {
        _pendingDestination.value = destination
    }

    fun consume(): String? {
        val dest = _pendingDestination.value
        _pendingDestination.value = null
        return dest
    }
}
